export default {
    about: 'About',
    create: 'Create Free Account',
    chatArchives: 'Chat Archives',
    contactSupport: 'Contact Support',
    feedback: 'Provide Feedback',
    hiddenModels: 'Hidden Models',
    ignoredModels: 'Ignored Models',
    login: 'Log In',
    logout: 'Log Out',
    manageAccount: 'Manage Account',
    modelsYouMayLike: 'Models You May Like',
    myAccount: 'My Account',
    mfcMail: 'MFC Mail',
    myNotes: 'My Notes',
    news: 'News Feed',
    privateGallery: 'Private Gallery',
    purchaseTokens: 'Purchase Tokens',
    support: 'Support',
    rewardPointsInfo:
        'Customers with high reward points receive priority support, access to special features throughout the site, and a big thank you from all of the models and staff at MyFreeCams!',
    purchaseLimitInfo:
        'You are currently limited to purchasing {dailyLimit} tokens per day, and to a maximum of {totalLimit} tokens that can be stored in your account at one time.\n\nPurchase limits are restrictions on the amount of purchases that a member can make. To learn more about purchase limits as well as to request to raise these limits, please contact support.',
}
